/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Filters from "../../../components/Filters";
import { ControlTable } from "../../../components/Table";
import { deleteMappingTaxInvoiceClient, directDeleteTaxInvoice, getTaxInvoiceList } from "../../../apis/invoices";
import { getParams } from "../../../utils/params";
import { autoHyphen } from "../../../utils/replace";
import useForm from "../../../hooks/useForm";
import { getDay } from "../../../utils/date";
import { useHistory } from "react-router-dom";
import { cloneDeep, isEmpty, findIndex } from "lodash";
import TaxInvoiceClientMapping from "../Tax/TaxInvoiceClientMapping";
import IconButton from "../../../components/Button/IconButton";
import DeleteIcon from "../../../assets/images/icon/delete-icon-01.svg";
import systemAlert from "../../../utils/systemAlert";
import TaxInvoiceToTradeInvoice from "../Tax/TaxInvoiceToTradeInvoice";
import Icon from "../../../components/Icon";
import CommentIcon from "../../../assets/images/icon/comment-icon.svg";
import { forEach } from "lodash";
import { transformComma } from "../../../utils/validator/comma";
import ToolTip from "../../../components/ToolTip/ToolTip";
import { clientPreview } from "../../../utils/client";
import { preventEvent } from "../../../utils/element";
import TaxInvoiceCreate from "../Tax/TaxInvoiceCreate";

const PaperTaxInvoicePurchase = ({
  open,
  setOpen,
  permission,
  excelDown = () => { }
}) => {
  const history = useHistory();
  const [sortFields, setSortFields] = useState([
    { key: 'writeDate', order: 'desc' },
    { key: 'issueDate', order: '' },
    { key: 'supBizNo', order: '' },
    { key: 'supCorpName', order: '' },
    { key: 'supRepName', order: '' },
    { key: 'itemName', order: '' },
    { key: 'itemSupAmt', order: '' },
    { key: 'itemTaxAmt', order: '' },
    { key: 'totalAmt', order: '' },
  ]);
  const [fields, setFields] = useState([]);
  const [taxInvoiceType] = useState("paper_tax_invoice");
  const [invoiceRegged] = useState(true);
  const [rowData, setRowData] = useState({});
  const [isInvoiceOpen, setIsInvoiceOpen] = useState(false);
  // 거래처 매핑
  const [isClientMappingOpen, setIsClientMappingOpen] = useState(false);
  const [clientMappingData, setClientMappingData] = useState(null);

  useEffect(() => {
    setFields([
      { title: "작성일자", key: "writeDate", type: 'date', className: 'nowrap', sort: (key) => handleSort(key), order: (key) => orderKey(key) },
      { title: "전송일자", key: "issueDate", type: 'date', className: 'nowrap', sort: (key) => handleSort(key), order: (key) => orderKey(key) },
      {
        title: "상호", key: "supCorpName", sort: (key) => handleSort(key), order: (key) => orderKey(key),
        onValue: (value, field, data) => {
          return <p
            onClick={(e) => {
              preventEvent(e);
              data?.client?.companyAccountIdx
                && clientPreview(data.client.companyAccountIdx);
            }
            }
          >{value}</p>;
        }
      },
      { title: "대표자명", key: "supRepName", sort: (key) => handleSort(key), order: (key) => orderKey(key) },
      {
        title: "사업자번호",
        key: "supBizNo",
        onValue: (value) => {
          return autoHyphen("comNum", value);
        },
        sort: (key) => handleSort(key), order: (key) => orderKey(key)
      },
      {
        // title: "대표품목", 
        title: "품목",
        key: "itemName",
        sort: (key) => handleSort(key),
        order: (key) => orderKey(key),
        onValue: (value, field, form) => {
          let itemsLabels = '';
          let items = form.taxInvoiceItems.length > 1
            ? `${form.itemName} 외 ${form.taxInvoiceItems.length - 1}건`
            : `${form.itemName}`;
          if (!isEmpty(form.taxInvoiceItems)) {
            forEach(form.taxInvoiceItems, (item) => {
              // if (item.order === 1) {
              //   items +=
              //     form.taxInvoiceItems.length > 1
              //       ? `${item.itemName} 외 ${form.taxInvoiceItems.length - 1}건`
              //       : `${item.itemName}`;
              // }
              const unit = item.unit || '개';
              itemsLabels += `${item.itemName}: ${transformComma(item.unitCost)}원 x ${item.itemQty}${unit} = ${transformComma(item.itemSupAmt + item.itemTaxAmt)}원 (부가세포함) \n`;
            });
          }

          return <>{items}<ToolTip
            position="bottom"
            tooltiptext={itemsLabels}
          /></>;
        },

      },
      {
        title: "공급가액",
        key: "supplyAmt",
        type: 'comma',
        className: 'nowrap',
        sortKey: 'itemSupAmt',
        sort: (key) => handleSort('itemSupAmt'), order: (key) => orderKey('itemSupAmt')
      },
      {
        title: "세액",
        key: "taxAmt",
        type: 'comma',
        className: 'nowrap',
        sortKey: 'itemTaxAmt',
        sort: (key) => handleSort('itemTaxAmt'), order: (key) => orderKey('itemTaxAmt')
      },
      {
        title: "합계금액",
        key: "totalAmt",
        type: 'comma',
        className: 'nowrap',
        sort: (key) => handleSort(key), order: (key) => orderKey(key)
      },
      {
        title: '',
        key: 'comments',
        onValue: (value) => {
          return (
            !isEmpty(value) ? (
              <>
                <Icon src={CommentIcon} />
                <span className="ml-4 font-bold">{value.count}</span>
              </>
            ) : (<></>)
          );
        }
      },
      {
        title: '매핑된 거래처',
        key: 'client',
        onValue: (value, field, data) => {
          return (
            !isEmpty(value) &&
            (
              <p className="pt-8 pb-8">
                <span className="vertical-middle">{value.name}</span>
                {permission.level > 1 && !data.isIssuedFromService && (
                  <IconButton className="ml-4 vertical-middle" icon={DeleteIcon} action={() => handleRemoveClient(data, value)} />)}
              </p>
            )
          );
        }
      }
    ]);
  }, [sortFields]);

  const {
    form,
    setSubmit,
    handleOnChange,
    handleSubmit,
    // LIST 용
    filterSubmit,
    reSubmit,
    list, setList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
    selectedList, setSelectedList,
    setOrderBy
  } = useForm({
    order: [{ writeDate: "desc" }],
    range: {
      writeDate: isEmpty(history.location.state) ? [getDay(7), getDay()] : history.location.state.date,
    },
    search: {
      supCorpName: ""
    },
    page: 0,
    limit: 10,
  });

  useEffect(() => {
    const sortField = sortFields.find((field) => !isEmpty(field.order));
    if (sortField) {
      setOrderBy(sortField);
    }
  }, [sortFields]);

  useEffect(() => {
    submit(form);
    setSubmit(submit);
  }, [taxInvoiceType, invoiceRegged]);

  useEffect(() => {
    excelDown({ form, taxInvoiceType, invoiceRegged });
  }, [form, taxInvoiceType, invoiceRegged]);

  const submit = (params) => {
    setIsLoading(true);
    let _params = cloneDeep(params);
    _params = {
      ..._params,
      ...invoiceRegged ? {} : { invoiceRegged: false }
    };
    getTaxInvoiceList("purchase", taxInvoiceType, { ...getParams(_params) })
      .then((res) => {
        const { totalCount, invoices, comment } = res.data;
        const transList = invoices.map((invoice) => ({
          ...invoice,
          comments: comment.listByPost.find(c => c.postIdx === invoice.idx) || {}
        }));
        setList(transList);
        setTotal(totalCount);
      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const filters = [
    {
      title: '조회기간 (작성일자)',
      type: 'customdatepicker',
      key: "range.writeDate"
    },
    {
      title: '상호명',
      key: "search.supCorpName"
    },
  ];

  const handleOnRowClick = (data, e) => {
    if (e.target.tagName !== "TR" && e.target.tagName !== "TD") return;
    setRowData(data);
    setOpen(true);
  };

  const handleRemoveClient = (data, value) => {
    systemAlert(`${value.name} 거래처 매핑을 삭제하시겠습니까?`, {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '삭제',
          onClick: () => {
            deleteMappingTaxInvoiceClient(data.idx).then(() => {
              filterSubmit();
            });
          }
        }
      ]
    });
  };

  const rowBtnConfig = {
    title: '거래처 매핑',
    rowButtons: [
      {
        // 거래처 매핑
        type: "edit",
        className: "mr-4",
        action: (data) => {
          setIsClientMappingOpen(true);
          setClientMappingData(data);
        },
      },
    ],
  };

  const tablebuttons = [
    {
      label: "종이세금계산서 삭제",
      color: "red",
      action: () => {
        systemAlert('선택한 종이세금계산서를 삭제하겠습니까?', {
          buttons: [
            {
              color: 'text',
              label: '취소'
            },
            {
              label: '삭제',
              color: 'red',
              onClick: () => {
                setIsLoading(true);
                directDeleteTaxInvoice({ idx: selectedList.map(item => item.idx) })
                  .then(res => {
                    setSelectedList([]);
                    filterSubmit();
                  })
                  .catch(() => { })
                  .finally(() => {
                    setIsLoading(false);
                  });
              }
            }
          ]
        });
      },
      disabled: isEmpty(selectedList),
    },
    {
      label: "거래명세서 발급",
      color: "gray-line",
      action: () => {
        setIsInvoiceOpen(true);
      },
      disabled: isEmpty(selectedList),
    },
  ];

  const handleSort = (key) => {
    const sortField = sortFields.find(field => field.key === key);
    const idx = findIndex(sortFields, sortField);
    let newArray = [...sortFields.map((field) => ({
      ...field,
      order: field.key !== key ? '' : field.order
    }))];
    newArray[idx] = {
      key,
      order: newArray[idx].order !== 'desc' ? 'desc' : 'asc'
    };
    setSortFields(newArray);
  };

  const orderKey = (key) => {
    const sortField = sortFields.find(field => field.key === key);
    return sortField.order;
  };


  return (
    <>
      <Filters
        filters={filters}
        isLoading={isLoading}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange} />
      <ControlTable
        isControl={permission.level > 1}
        buttons={permission.level > 1 ? tablebuttons : []}
        isLoading={isLoading}
        fields={fields}
        sortField={sortFields.find((field) => !isEmpty(field.order))}
        list={list}
        selectedList={selectedList}
        setSelected={setSelectedList}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        total={total}
        submit={handleSubmit}
        onSelect={handleOnRowClick}
        rowBtn={rowBtnConfig}
      />
      {open && (
        <TaxInvoiceCreate
          open={open}
          setOpen={setOpen}
          supByrType={'purchase'}
          submit={reSubmit}
          direct={"paper_tax_invoice"}
          list={rowData}
          setList={setRowData}
          mode={!isEmpty(rowData) ? "detail" : "create"}
          permission={permission}
        />
      )}
      {isInvoiceOpen && (
        <TaxInvoiceToTradeInvoice
          open={isInvoiceOpen}
          setOpen={setIsInvoiceOpen}
          list={selectedList}
          setList={setSelectedList}
          submit={reSubmit}
          type="purchase"
        />
      )}
      {isClientMappingOpen && (
        <TaxInvoiceClientMapping
          open={isClientMappingOpen}
          setOpen={setIsClientMappingOpen}
          data={clientMappingData}
          setData={setClientMappingData}
          submit={reSubmit}
          invoiceType="paper-tax-invoice"
        />
      )}
    </>
  );
};

export default PaperTaxInvoicePurchase;
